import { render } from "./sites.vue?vue&type=template&id=9fbd7c90"
import script from "./sites.vue?vue&type=script&lang=ts"
export * from "./sites.vue?vue&type=script&lang=ts"
script.render = render

export default script